/**
 * Tells a HCPCS Level II billing code (one capital letter and four digits, e.g. `J1050`) apart
 * from the HCPCS modifiers (two characters, e.g. `BO`) stored in the same code system. Medplum
 * cannot filter the HCPCS code system by term type, so this check runs on its search results.
 *
 * @param code The code to check, as stored in the terminology server.
 * @returns True when the code is a HCPCS Level II billing code.
 */
export function isHcpcsLevelIICode(code: string): boolean {
  return HCPCS_LEVEL_II_CODE_PATTERN.test(code);
}

const HCPCS_LEVEL_II_CODE_PATTERN = /^[A-Z][0-9]{4}$/;
